/* ============================================================================
   CHECKPOINT - custom.js
   ----------------------------------------------------------------------------
   Personalizzazioni JS estratte da assets/theme.js (Stretch 1.4.1) durante la
   migrazione a Stretch 2.1.0.
   theme.js torna VANILLA: i futuri aggiornamenti del tema non generano conflitti.
   Tutto e' incapsulato in una IIFE per non inquinare lo scope globale.
   ========================================================================== */
(() => {
  "use strict";

  const createCartPromise = async () => {
    const response = await fetch(`${Shopify.routes.root}cart.js`);
    if (!response.ok) {
      throw new Error(`Failed to fetch cart: ${response.statusText}`);
    }
    return await response.json();
  };
  
  const generateFidelityCoupon = async () => {
    const cartObj = await createCartPromise(),
          cartId = cartObj.token,
          customerId = atob(window.customerId),
          endpoint = atob(window.fidelityApiUrl);
  
          try {
            const response = await fetch(endpoint, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(
                { 
                  "cart": cartId,
                  "customer": customerId
                }
              ),
            });
      
            if (!response.ok) {
              throw new Error(`Failed to generate coupon: ${response.statusText}`);
            }
            const data = await response.json();
            window.CHECKPOINT_FIDELITY_LAST_RESPONSE = data;
            console.info('[CHECKPOINT fidelity] risposta API:', data);
            const {success, coupon} = data;
  
          if (success && coupon) {
            await applyCouponToCart(data.coupon);
          }
  
            return data;
          } catch (error) {
            console.error('[CHECKPOINT fidelity] errore chiamata coupon:', error);
            window.CHECKPOINT_FIDELITY_LAST_ERROR = String(error);
            return { success: false, message: 'REQUEST_FAILED' };
          }
  }
  
  const applyCouponToCart = async (couponCode) => {
    try {
      const response = await updateCartWidthCoupon(couponCode);
      if (!response.ok) {
        throw new Error(`Failed to apply coupon: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Error applying coupon to cart:', error);
    }
  }
  
  const updateCartWidthCoupon = async (couponCode) => {
    let body = '';
    if (couponCode) {
      body = JSON.stringify({
        discount: couponCode,
      });
    }
    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: body,
    });
    return response;
  }
  

  /* --- tracciamento coupon fidelity sul carrello ------------------------- */
  let hasFidelityCoupon = false;

  document.addEventListener("cart:change", async (event) => {
    const cart = event.detail["cart"];

    if (cart && Array.isArray(cart.discount_codes)) {
      cart.discount_codes.forEach((discount) => {
        if (discount.code.includes("FIDELITY")) {
          hasFidelityCoupon = true;
        }
      });
    }

    if (hasFidelityCoupon) {
      await generateFidelityCoupon();
    }
  });

  /* --- custom element <apply-points-button> ------------------------------ */
  class ApplyPointsButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this.handleClick.bind(this));
      this.refreshCoupon();
    }
  
    connectedCallback() {
      const applyPointsModal = document.querySelector('#apply-points-modal'),
            applyPointsModalCloseButton = applyPointsModal.querySelector('.close');
      if (applyPointsModalCloseButton) {
        applyPointsModalCloseButton.addEventListener('click', () => {
          document.querySelector('html').classList.remove('lock', 'overlay');
          applyPointsModal.classList.add('hidden');
        });
      }
    }
  
    manageErrorMessage(messakey) {
      switch (messakey) {
        case 'NO_FIDELITY_POINTS_AVAILABLE':
          return window.translations.no_fidelity_points_available;
        case 'NO_ELIGIBLE_PRODUCTS':
          return window.translations.no_eligible_products;
        case 'NO_FIDELITY_CARD':
          return window.translations.no_fidelity_card;
        case 'DISCOUNTABLE_AMOUNT_LESS_THAN_AVAILABLE_POINTS':
          return window.translations.discountable_amount_less_than_available_points;
        default:
          console.warn('[CHECKPOINT fidelity] codice errore non gestito dal tema:', messakey);
          return window.translations.general_error;
      }
    }
  
    async handleClick() {
      const applyPointsModal = document.querySelector('#apply-points-modal');
      const response = (await generateFidelityCoupon()) || { success: false, message: 'NO_RESPONSE' };
  
      const {success, message, coupon} = response;
  
        if (success && coupon) {
          window.location.reload();
        }
  
        if (!success) {
          applyPointsModal.querySelector('.message').innerHTML = this.manageErrorMessage(message);
          document.querySelector('html').classList.add('lock', 'overlay');
          applyPointsModal.classList.remove('hidden');
        }
    }
  
    async refreshCoupon() {
      await updateCartWidthCoupon();
    }
  }
  
  // Define the custom element
  if (!window.customElements.get("apply-points-button")) {
    window.customElements.define("apply-points-button", ApplyPointsButton);
  }
  
})();
